import React, { useEffect, useState } from 'react';

import LoadingAnimation from '../../../../assets/animations/loading.gif';
import { IBdsLoadingFullScreen } from '../../../interfaces/bdsLoadingFullScreen';
import './BdsLoadingFullScreen.scss';

const BdsLoadingFullScreen = ({ show, text }: IBdsLoadingFullScreen) => {
  const [wasShown, setWasShown] = useState(false);

  useEffect(() => {
    if (show) {
      setWasShown(true);
    }
  }, [show]);

  return (
    <div
      className={`bds-loading-full-screen flex flex-col justify-center items-center w-full h-full ${
        show ? 'show' : wasShown ? 'hide' : ''
      }`}
    >
      <div className="loading-img flex justify-center items-center">
        <img src={LoadingAnimation} alt="btf-loading-animation" />
      </div>
      <div className="loading-text">{text}</div>
    </div>
  );
};

export default BdsLoadingFullScreen;
